import { Stack } from '@mui/material';
import { NoResults } from '../../shared/NoResults';
import {
  SelectedDependencyWithClearHistoryProps,
  ConfigurationType,
  SelectedDependency,
  DependenciesContentViewType,
} from '../../dependencies/types';
import { OCCUPIED_SPACE_SINGLE_OBJECT_VIEW_CANVAS } from '../../helpers';
import { ListElementWrapper } from '../../shared/ListElementWrapper';
import { getRecordTypeIdentifier } from '../../../pages/configuration-canvas/utils/getRecordTypeIdentifier';
import { CardContent } from './CardContent';
import { useCardListHandleDeepLink } from './useCardListHandleDeepLink';
import { useIsCanvasUnited } from '../../../../hooks/useIsCanvasUnited';

interface CardListProps {
  list: CardListItem[];
  containerRef?: any;
  firstHistoryItem?: SelectedDependency;
  handleSetConfigurationItem: (props: SelectedDependencyWithClearHistoryProps) => void;
  withDetailedContentForRelatedObjects?: boolean;
  withApiNameOnHover?: boolean;
}

export interface CardListItem {
  id: string;
  dependencyType: string;
  parentType: ConfigurationType;
  name: string;
  label: string;
  objectName: string;
  referencedObjects: string[];
  changedAt?: string;
  changedBy?: string;
  isActive: boolean;
}

export const CardsList = ({
  list,
  containerRef,
  firstHistoryItem,
  handleSetConfigurationItem,
  withDetailedContentForRelatedObjects: withDetailedContent,
  withApiNameOnHover,
}: CardListProps) => {
  const isCanvasUnited = useIsCanvasUnited();
  useCardListHandleDeepLink({ list, handleSetConfigurationItem });

  return (
    <Stack
      ref={containerRef}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: `calc(100vh - ${
          isCanvasUnited ? OCCUPIED_SPACE_SINGLE_OBJECT_VIEW_CANVAS : '250spx'
        })`,
        overflowY: 'auto',
        overflowX: 'hidden',
      }}
    >
      {list.length ? (
        list.map((item) => {
          return (
            <Stack key={'wrapper_' + item.id}>
              <ListElementWrapper
                elementId={getRecordTypeIdentifier(item.name, item.objectName)}
                sx={{
                  minHeight: '64px',
                  pr: 0,
                  pl: 0,
                  pt: 1.5,
                  pb: 1.5,
                }}
                onWrapperClick={() => {
                  handleSetConfigurationItem({
                    id: item.id,
                    dependencyType: item.dependencyType,
                    parentType: item.parentType,
                    name: item.name,
                    objectName: item.objectName,
                    clearHistory: true,
                    contentType: DependenciesContentViewType.default,
                  });
                }}
                isHighlighted={
                  firstHistoryItem?.id
                    ? firstHistoryItem?.id === item.id
                    : firstHistoryItem?.name === item.name &&
                      firstHistoryItem?.objectName === item.objectName
                }
                leftContent={
                  <CardContent
                    parentType={item.parentType}
                    label={item.label}
                    apiName={item.name}
                    date={item.changedAt ?? ''}
                    isActive={item.isActive}
                    objectNames={item.referencedObjects}
                    parentObject={item.objectName}
                    dependencyType={item.dependencyType}
                    withDetailedContentForRelatedObjects={withDetailedContent}
                    withApiNameOnHover={withApiNameOnHover}
                  />
                }
              />
            </Stack>
          );
        })
      ) : (
        <Stack pl={2}>
          <NoResults />
        </Stack>
      )}
    </Stack>
  );
};
